import React from 'react';
import { Dialog, Switch, Select, AutoComplete } from '@tencent/spaui';
import { RPCFactory } from '../../../../utils/RequestUtil';
import { useCheckWhiteList } from '../../../../utils/checkWhiteList';
import { Tags } from '../../../../consts/Tags';
import { employeeStrategyMap, settingMap, groupStrategyMap } from './config';
import { getStandardFieldMap } from './../../../../components/helper/RuleApplyRangeHelper';
import { actionSubType } from './actionSubType';
import { leadsSourceMap, leadsSubSourceMap, xuanjLeadsSubSourceMap } from './leadsSourceMap';
import { getEmployeeNames, getGroupNames } from './helper';
import ABulkMiniDialog from '../../businessSetting/ABulkMiniDialog';
import { store } from '../../../../store/Store';
import { GlobalStateAction } from '../../../../actions/GlobalStateAction';

import useList from '../../../../leads_component/shared-components/hooks/useList';
import useDeleteDialog from '../../../../leads_component/shared-components/hooks/useContentDialog';
import useDialog from '../../../../leads_component/shared-components/hooks/useDialog';

import EditContent from './editRule';

const searchItems = [
  { value: 'ruleName', label: '规则名称' },
  { value: 'adCampaignName', label: '广告/推广计划' },
];
const CustomizedRule = (props) => {
  const ruleListHooks = useList();
  const [isSort, setSort] = React.useState(false);
  const deleteConfirmHooks = useDeleteDialog({ showDialog: false });
  const ruleEditHooks = useDialog({ showDialog: false });
  const [dragItem, setDragItem] = React.useState(-1);
  const [searchItemKey, setSearchItemKey] = React.useState('');
  const [searchItemValue, setSearchItemValue] = React.useState('');
  const [refresh, setRefresh] = React.useState(false);
  const isXundaAccount = window.pageProps.xundaOuterCode !== 0;
  const isShowXjLeadsSubSource = !!window.pageProps && useCheckWhiteList(window.pageProps.uid, 'xuanjing_config');
  const standardFieldMap = getStandardFieldMap({ isShowXjLeadsSubSource });
  const getRuleList = () => {
    store.dispatch({ type: GlobalStateAction.SHOW_LOADING });
    let searchPara = searchItemKey == '' ? '': `&${searchItemKey}=${searchItemValue}`;

    RPCFactory.leadsSetting.getCustomizedRules(searchPara).done((data) => {
      ruleListHooks.setDataList(data.entities);
      store.dispatch({ type: GlobalStateAction.HIDE_LOADING });
    })
    .fail((ret, msg) => {
      store.dispatch({ type: GlobalStateAction.HIDE_LOADING });
      window.alert(`获取自定义规则失败，错误信息：${msg}`);
    });
  };
  React.useEffect(() => {
    if(refresh) {
      getRuleList();
    }
  }, [refresh]);
  React.useEffect(() => {
    getRuleList();
  }, []);

  const renderTitle = (ele) => {
    let res = `${ele.ruleName || '未知'}  线索范围:`;
    if (ele.applyRange.applyRangeType == 'ALL') {
      return `${ele.ruleName || '未知'}  线索范围: 全部`;
    }
    ele.applyRange.applyRangeDetail.forEach((field) => {
      const key = field.fieldName;
      if (field.fieldScope == 'BUNDLE') {
        res = ` ${res}${key} ${field.fieldValues.join(',')} `;
      } else if (key == 'leadsSource') {
        res = ` ${res}${standardFieldMap[key] ? standardFieldMap[key].label : ''} ${field.fieldValues
          .map((ele) => leadsSourceMap[ele])
          .join(',')} `;
      } else if (key == 'leadsSubSource') {
        res = ` ${res}${standardFieldMap[key] ? standardFieldMap[key].label : ''} ${field.fieldValues
          .map((ele) => leadsSubSourceMap[ele] || xuanjLeadsSubSourceMap[ele])
          .join(',')} `;
      } else if (key == 'actionSubType__leadsSubType') {
        res = ` ${res}${standardFieldMap[key] ? standardFieldMap[key].label : ''} ${field.fieldValues
          .map((ele) => actionSubType[ele] || Tags.leadsSubTypeTag[ele].desc)
          .join(',')} `;
      } else {
        res = ` ${res}${standardFieldMap[key] ? standardFieldMap[key].label : ''} ${field.fieldValues.join(',')} `;
      }
    });

    return res;
  };

  const onDelete = () => {
    RPCFactory.leadsSetting
      .deleteCustomizedRules({
        ruleId: deleteConfirmHooks.data.ruleId,
      })
      .done((data) => {
        getRuleList();
        deleteConfirmHooks.setShow(false);
      })
      .fail((code, msg) => {
        props.feedbackHooks.showErrorTip(msg);
      });
  };

  const handleAdd = () => {
    ruleEditHooks.showAsAddModel();
  };

  const handleCancel = () => {
    setSort(false);
    getRuleList();
  };

  const handleSave = () => {
    RPCFactory.leadsSetting
      .sortCustomizedRules({
        ruleIds: ruleListHooks.dataList.map((ele) => ele.ruleId).slice(0, -1),
      })
      .done((data) => {
        setSort(false);
        getRuleList();
      })
      .fail((code, msg) => {
        alert(msg);
      });
  };

  const handleDrop = (e, index) => {
    if (!isSort) {
      return;
    }
    if (index == ruleListHooks.dataList.length - 1) {
      return;
    }
    ruleListHooks.onItemSwitch(dragItem, index);
  };
  const handleChange = (ele, index) => {
    if (ele.pauseStatus === 0) {
      ele.pauseStatus = 1;
    } else if (ele.pauseStatus === 1) {
      ele.pauseStatus = 0;
    }
    ruleListHooks.onItemChangeBatch(index, {
      pauseStatus: ele.pauseStatus,
    });
    RPCFactory.leadsSetting
      .ruleStatusUpdate({
        ruleId: ele.ruleId,
        pauseStatus: ele.pauseStatus,
      })
      .done((data) => {
        console.log(data, 'data');
      })
      .fail((ret, msg) => {
        alert(`请求失败，msg:${msg}`);
      });
  };
  
  const onChangeSearchItem = (event, value) => {
    setSearchItemKey(value);
    setRefresh(false);
  };
  const onClearSearchItemValue = (event) => {
    setSearchItemValue('');
    setRefresh(false);
  };
  
  const onClearSearchItem = (event) => {
    setSearchItemKey('');
    setSearchItemValue('');
    setRefresh(true);
    // setTimeout(() => {
    //   getRuleList();
    // }, 200);
  };

  const onChangeSearchItemValue = (event, value) => {
    setSearchItemValue(value);
    setRefresh(false);
  };
  const onKeyPressHandler = (event, value) => {
    if (event.key == 'Enter') {
      // getRuleList();
      setRefresh(true);
    }
  };

  const renderRule = (ele, index) => {
    const isLast = index == ruleListHooks.dataList.length - 1;
    const target = ele.leadsDistriTarget;
    const selectedDistributor = target === 'USER' ? ele.leadsDistriEmployees : ele.leadsDistriGroups;
    const distributorNames =
      target === 'USER'
        ? getEmployeeNames(props.employeeList, selectedDistributor).join(',')
        : getGroupNames(props.groupList, selectedDistributor).join(',');
    const strategyMap = target === 'USER' ? employeeStrategyMap : groupStrategyMap
    return (
      <li
        className={isLast || !isSort ? 'item' : 'item dragged'}
        draggable={!isLast && isSort}
        onDragStart={() => {
          setDragItem(index);
        }}
        onDrop={(event) => handleDrop(event, index)}
        onDragOver={(e) => {
          e.preventDefault();
        }}
      >
        <span className="item-left">{index + 1}</span>
        <div className="item-right">
          <div className="content">
            <p className="tt">{ele.applyRange.applyRangeType != 'ELSE' ? renderTitle(ele) : '剩余线索分配'}</p>
            <p className="desc">
              {ele.applyRange.applyRangeType === 'ELSE' && isLast ?
                  <p>
                    {
                      distributorNames ? <p style={{ display: 'block' }}>负责员工：{distributorNames}</p>:
                          <p style={{ color: 'red', display: 'block' }}>负责员工：{distributorNames}</p>
                    }
                  </p>
                  : <p>{`负责${target === 'USER' ? '员工' : '团队'}: ${distributorNames}`}</p>}

              <span>{`分配规则: ${strategyMap.find((e) => e.key == ele.leadsDistriStrategy).title}`}</span>
            </p>
          </div>
        </div>
        {isSort ? null : (
            <div className="action">
              <Switch
                checked={ruleListHooks.dataList[index].pauseStatus === 0}
                onChange={() => {
                  handleChange(ele, index);
                }}
              ></Switch>
              <a
                aria-label="编辑"
                className="editable-icon"
                onClick={() => {
                  ruleEditHooks.showAsEditModel(ele);
                }}
              >
                <i className="icon icon-pen"></i>
              </a>
              {isLast ? null : (
                <a
                  aria-label="删除"
                  className="editable-icon"
                  onClick={() => {
                    deleteConfirmHooks.openDialog(ele);
                  }}
                >
                  <i className="icon icon-close"></i>
                </a>
              )}
            </div>
          )}
      </li>
    );
  };
  return (
    <div className="sec baserule-sec save">
      <div className="card">
        <div className="panel base-set">
          <div className="tt-wraper fe-flex-spacebetween">
            <em className="tt">
              <strong>自定义规则分配</strong>
            </em>
            <div className="action-wraper">
              {isSort ? null : (
                <a
                  className="edit"
                  onClick={() => {
                    setSort(true);
                  }}
                >
                  排序
                </a>
              )}
              {
                props.type !== settingMap[2].key && !isSort ? (
                  <a
                    className="edit"
                    onClick={() => props.apply(settingMap[2].key)}
                  >
                    应用规则
                  </a>
                ) : (
                  <a
                    className="edit"
                    onClick={() => props.cancelApply(settingMap[2].key)}
                  >
                    取消应用
                  </a>
                )
              }
            </div>
          </div>
          <em className="tt desc">线索将按以下规则的先后顺序分配，点击排序后可拖拽调换规则顺序</em>
          <div className="rules">
            <div className="datarea">
              <div className="toolbars">
                <div id="customrule_dialog" className="toolbar table-toolbar">
                  <div className="toolbar-left">
                    {isSort && isXundaAccount ? null : (
                      <a className="edit" onClick={handleAdd}>
                        ＋添加自定义规则
                      </a>
                    )}
                  </div>
                  <div className="toolbar-right">
                      <Select
                        data={searchItems}
                        value={searchItemKey}
                        onChange={onChangeSearchItem}
                        onClear={onClearSearchItem}
                        clearable
                      />
                      <AutoComplete
                        value={searchItemValue}
                        onKeyPress={onKeyPressHandler}
                        onChange={onChangeSearchItemValue}
                        onClickSearchIcon={getRuleList}
                        onClear={onClearSearchItemValue}
                      />
                    </div>
                </div>
              </div>
            </div>
            {ruleListHooks.dataList.length == 0 && <div>抱歉，暂无相关规则记录</div> }
            <ul className="custom-infolist">{ruleListHooks.dataList.map((ele, index) => renderRule(ele, index))}</ul>
          </div>
          {isSort ? (
            <div className="action-wraper">
              <button className="spaui-button spaui-button-default" type="button" onClick={handleCancel}>
                取消
              </button>
              <button className="spaui-button spaui-button-primary" type="button" onClick={handleSave}>
                保存
              </button>
            </div>
          ) : null}
        </div>
      </div>
      <ABulkMiniDialog
        show={deleteConfirmHooks.show}
        onSubmit={onDelete}
        onCancel={deleteConfirmHooks.onClose}
        width={'280px'}
        eventTargetPlacement={'left'}
        title={''}
      >
        <div className="confirmbox confirmbox-del">
          <div className="content">
            <p className="tt">确定删除该自定义规则？</p>
            <p className="des">删除后不可恢复，请谨慎操作。</p>
          </div>
        </div>
      </ABulkMiniDialog>
      {ruleEditHooks.showDialog ? (
        <Dialog
          backdrop
          type="normal"
          title={ruleEditHooks.model === 'add' ? '添加自定义规则' : '编辑自定义规则'}
          className="customrule-dialog"
          style={{ width: '918px' }}
          hideFooter
          {...ruleEditHooks.props}
        >
          <EditContent
            {...ruleEditHooks.contentProps}
            isXundaAccount={isXundaAccount}
            employeeList={props.employeeList}
            groupList={props.groupList}
            onCancel={ruleEditHooks.onCancel}
            onSubmit={() => {
              ruleEditHooks.onSubmit();
              getRuleList();
            }}
          />
        </Dialog>
      ) : null}
    </div>
  );
};

export default CustomizedRule;
